import { extend } from './extend'
import base from './base'

// VoiceToMe's orange, as the portal uses it (system.voicetome.com.json brand.colors).
export default extend(base, {
  primary: {
    lighter: '#f5a940',
    default: '#f18e00',
    darker: '#c27200',
  },
})
